
import { defineComponent } from "vue";

import FeatureCatalogue from "@/components/catalogues/FeatureCatalogue/FeatureCatalogue.vue";

export default defineComponent({
  components: { FeatureCatalogue },
  props: {},
  methods: {},
  data() {
    return {};
  },
});
